import React, { useMemo } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdBusinessCenter,
	MdOutlineBusiness,
	MdOutlineMessage,
	MdPanoramaPhotosphere,
	MdSettingsSuggest,
	MdTrackChanges,
	MdTune,
} from "react-icons/md";
import { Link } from "react-router-dom";
import {
	ApartmentOutlined,
	CalendarOutlined,
	ClusterOutlined,
	DatabaseOutlined,
	GlobalOutlined,
	HeartOutlined,
	IdcardOutlined,
	StockOutlined,
} from "@ant-design/icons";
import { Badge } from "antd";
import { BiBox, BiCheckCircle, BiImport } from "react-icons/bi";
import { IoCodeOutline, IoGitNetworkOutline } from "react-icons/io5";
import {
	GiArtificialIntelligence,
	GiComputing,
	GiFiles,
	GiToken,
} from "react-icons/gi";
import { COLORS } from "../../../../../layout/theme";

export default function ModuleOneTransfer({
	userdata,
	userRol,
	toValidateQty,
	agentOrdersQty,
	activeSection,
}) {
	const generalItems = useMemo(
		() => [
			{
				to: "/admin/clients?uri=generalConfig",
				title: "Clientes",
				desc: "Administracion de contratos y clientes",
				icon: <DatabaseOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/marketUsers?uri=generalConfig",
				title: "Usuarios",
				desc: "Gestión de usuarios y permisos del sistema",
				icon: <IdcardOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/chains?uri=generalConfig",
				title: "Cadenas",
				desc: "Configuración de cadenas y relaciones",
				icon: <IoGitNetworkOutline size={16} />,
			},
			{
				to: "/admin/codeChanges?uri=generalConfig",
				title: "Códigos de cliente",
				desc: "Seguimiento de cambios de codigos",
				icon: <IoCodeOutline size={16} />,
			},
			{
				to: "/admin/distributorStatus?uri=generalConfig",
				title: "Estado Droguerías",
				desc: "Monitoreo del estado de las droguerías",
				icon: <HeartOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/paymentTerms?uri=generalConfig",
				title: "Términos de pago",
				desc: "Gestión de condiciones y plazos de pago",
				icon: <CalendarOutlined style={{ fontSize: 16 }} />,
			},
		],
		[],
	);

	const pdvGeneralItems = useMemo(
		() => [
			{
				to: "/admin/generalPointsOfSale?uri=generalConfig",
				title: "Tabla general",
				desc: "Administración de la tabla general de PDV",
				icon: <MdPanoramaPhotosphere size={16} />,
			},
			{
				to: "/admin/importGeneralPos?uri=generalConfig",
				title: "Importador PDV general",
				desc: "Importación masiva de PDV generales",
				icon: <BiImport size={16} />,
			},
			{
				to: "/generalPosConfig?uri=generalConfig",
				title: "Gestión PDV general",
				desc: "Configuración global de puntos de venta",
				icon: <GlobalOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/generalPosToValidate?uri=generalConfig",
				title: "PDV de solicitudes a validar",
				desc: "Validación de solicitudes pendientes",
				icon: <BiCheckCircle size={16} />,
				badge: toValidateQty,
			},
		],
		[toValidateQty],
	);

	const businessItems = useMemo(
		() => [
			{
				to: "/admin/distributors?uri=generalConfig",
				title: "Droguerías",
				desc: "Configuración y administración",
				icon: <ApartmentOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/distributorsIndex?uri=generalConfig",
				title: "Distribuidores",
				desc: "Configuración y administración",
				icon: <ClusterOutlined style={{ fontSize: 16 }} />,
			},
		],
		[],
	);

	const iaItems = useMemo(
		() => [
			{
				to: "/admin/laboratorySuggestions?uri=generalConfig",
				title: "Configuración de Sugeridos",
				desc: "Parámetros de configuracion para sugeridos",
				icon: <MdTune size={16} />,
			},
			{
				to: "/admin/suggestedProducts?uri=generalConfig",
				title: "Listado de Sugeridos",
				desc: "Visualización y gestión de sugeridos activos",
				icon: <StockOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/laboratoryAgentPool?uri=generalConfig",
				title: "Ruteo Agente",
				desc: "Configuración del ruteo del agente",
				icon: <MdTrackChanges size={16} />,
			},
			{
				to: "/admin/laboratoryAgentConversations?uri=generalConfig",
				title: "Conversaciones Agente",
				desc: "Historial de conversaciones",
				icon: <MdOutlineMessage size={16} />,
			},
			{
				to: "/admin/laboratoryAgentOrders?uri=generalConfig",
				title: "Pedidos Agente",
				desc: "Pedidos gestionados por el agente",
				icon: <BiBox size={16} />,
				badge: agentOrdersQty,
			},
			{
				to: "/admin/laboratoryAgentConfigs?uri=generalConfig",
				title: "Configuración Agente",
				desc: "Parámetros de configuracion de los agentes",
				icon: <MdSettingsSuggest size={16} />,
			},
			{
				to: "/admin/agentPanel?uri=generalConfig",
				title: "Panel Agentes",
				desc: "Creacion y administracion de agentes",
				icon: <GiArtificialIntelligence size={16} />,
			},
			{
				to: "/admin/laboratoryMarketing?uri=generalConfig",
				title: "Material de Marketing",
				desc: "Gestión de material para marketing",
				icon: <GiFiles size={16} />,
			},
			{
				to: "/admin/agentTemplates?uri=generalConfig",
				title: "Configuración de Plantillas",
				desc: "Gestión de plantillas del agente",
				icon: <GiComputing size={16} />,
			},
			{
				to: "/admin/iaPlans?uri=generalConfig",
				title: "Configuración de Planes",
				desc: "Gestión de planes y tokens",
				icon: <GiToken size={16} />,
			},
		],
		[agentOrdersQty],
	);

	const panel =
		activeSection === "pdvGeneral"
			? {
					eyebrow: "PDV General",
					title: "Gestión Tabla PDV General",
					desc: "Sección para administrar tabla referencia",
					icon: <MdPanoramaPhotosphere size={20} />,
					iconBg: COLORS.LightPrimary, //"#E6F1FB",
					iconColor: COLORS.Primary, //"#185FA5",
					items: pdvGeneralItems,
				}
			: activeSection === "business"
				? {
						eyebrow: "Negocio",
						title: "Configuración del Negocio",
						desc: "Variables principales del negocio",
						icon: <MdBusinessCenter size={20} />,
						iconBg: COLORS.LightSecondary, //"#EEEDFE",
						iconColor: COLORS.Secondary, //"#534AB7",
						items: businessItems,
					}
				: activeSection === "ia"
					? {
							eyebrow: "IA",
							title: "Inteligencia Artificial",
							desc: "Configuración de aplicaciones y agentes IA",
							icon: <GiArtificialIntelligence size={20} />,
							iconBg: "#E1F5EE",
							iconColor: "#0F6E56",
							items: iaItems,
						}
					: {
							eyebrow: "Configuración General",
							title: "Checkpos Transfer",
							desc: "Accesos principales para administrar el sistema",
							icon: <MdOutlineBusiness size={20} />,
							iconBg: "#E6F1FB",
							iconColor: "#185FA5",
							items: generalItems,
						};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<Badge
									count={item.badge}
									offset={[8, -4]}
									size="small"
									color="#E24B4A"
								>
									<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
										{item.icon}
									</CardIconWrap>
								</Badge>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
